import { Select } from "flowbite-react";
import propTypes from "prop-types";

export function CommonDropdown({ dataList = [], type = "", handleChange = () => null, value = null, disbaled = false }) {
    return (
        <div className="max-w-sm ">
            <Select
                value={value}
                theme={{
                    "addon": "inline-flex items-center rounded-l-md border-0 bg-white px-3 text-base text-secondary-500",
                    "field": {
                        "base": "relative w-full focus:border-0",
                        "select": {
                            "base": "focus:!border-0 focus:!ring-0  block w-full !text-base !text-secondary-500 !bg-white border-0 disabled:cursor-not-allowed disabled:opacity-50",
                        },
                        "colors": {
                            "gray": "border-0 bg-white text-base text-secondary-500",
                        }
                    }
                }}
                color="gray"
                disbaled={disbaled}
                onChange={(e) => handleChange(e, type)}
                sizing="sm">
                {!!dataList?.length && dataList?.map(month => <option className="text-sm text-secondary-500 cursor-pointer" value={month?.value} key={month?.value}>{month?.label}</option>)}
            </Select>
        </div >
    );
}

CommonDropdown.propTypes = {
    dataList: propTypes.array,
    type: propTypes.string,
    handleChange: propTypes.func,
    value: propTypes.any,
    disbaled: propTypes.bool
}